"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Set = _interopRequireDefault(require("../codec/Set"));

// Copyright 2017-2019 @polkadot/types authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * @name WithdrawReasons
 * @description
 * The Substrate WithdrawReasons for staking
 */
class WithdrawReasons extends _Set.default {
  constructor() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    super({
      TransactionPayment: 0b00000001,
      Transfer: 0b00000010,
      Reserve: 0b00000100,
      Fee: 0b00001000
    }, value);
  }
  /**
   * @description In order to reserve some funds for a later return or repatriation
   */


  get isReserve() {
    return this.values.includes('Reserve');
  }
  /**
   * @description In order to pay for (system) transaction costs
   */


  get isTransactionPayment() {
    return this.values.includes('TransactionPayment');
  }
  /**
   * @description In order to transfer ownership
   */


  get isTransfer() {
    return this.values.includes('Transfer');
  }
  /**
   * @description /// In order to pay some other (higher-level) fees.
   */


  get isFee() {
    return this.values.includes('Fee');
  }

}

exports.default = WithdrawReasons;